const mountWishlist = () => {
  const details = document.querySelector('.product-details');
  const slot = details?.querySelector('.dd-pdp-wishlist-slot');
  const widget = details?.querySelector('joy-wishlist-button[type="product"]');
  if (!slot || !widget) return;
  const wrapper = widget.closest('.Joy-Wishlist-ButtonWrapper') || widget;
  if (wrapper.parentElement !== slot) slot.append(wrapper);
  const root = widget.shadowRoot;
  if (root && !root.querySelector('[data-dd-heart-style]')) {
    const style = document.createElement('style');
    style.dataset.ddHeartStyle = '';
    style.textContent = '.Joy-Wishlist__Button{width:52px!important;height:52px!important;min-height:52px!important;padding:0!important;margin:0!important;border:1px solid #d9d9d9!important;border-radius:3px!important;display:flex!important;align-items:center!important;justify-content:center!important;background:#fff!important}.Joy-Wishlist-WishlistButton__Text{display:none!important}.Joy-Wishlist-WishlistButton__Icon{display:flex!important;margin:0!important}.Joy-Wishlist__Button:focus-visible{outline:2px solid #965c25!important;outline-offset:3px}';
    root.append(style);
  }
};
let pending = false;
const schedule = () => {
  if (pending) return;
  pending = true;
  requestAnimationFrame(() => { pending = false; mountWishlist(); });
};
const observer = new MutationObserver(schedule);
observer.observe(document.body, { childList: true, subtree: true });
customElements.whenDefined('joy-wishlist-button').then(schedule);
schedule();
